var objStrict = require('./objStrict')
var isFunction = require('./function')

/**
 * @func isObj
 *
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @return {boolean} Returns `true` if `value` is an object, else `false`.
 *
 * @memberOf is
 * @see https://github.com/lodash/lodash/blob/master/isObject.js
 * @NOTE Object.prototype.toString.call(val) === '[object Object]'
 *
 * @example
 *
 * isObject({})
 * // => true
 *
 * isObject([1, 2, 3])
 * // => true
 *
 * isObject(Function)
 * // => true
 *
 * isObject(null)
 * // => false
 */
module.exports = function (x) { return objStrict(x) || isFunction(x); }

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib2JqLmpzIiwic291cmNlcyI6WyJvYmouanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3Qgb2JqU3RyaWN0ID0gcmVxdWlyZSgnLi9vYmpTdHJpY3QnKVxuY29uc3QgaXNGdW5jdGlvbiA9IHJlcXVpcmUoJy4vZnVuY3Rpb24nKVxuXG4vKipcbiAqIEBmdW5jIGlzT2JqXG4gKlxuICogQ2hlY2tzIGlmIGB2YWx1ZWAgaXMgdGhlXG4gKiBbbGFuZ3VhZ2UgdHlwZV0oaHR0cDovL3d3dy5lY21hLWludGVybmF0aW9uYWwub3JnL2VjbWEtMjYyLzcuMC8jc2VjLWVjbWFzY3JpcHQtbGFuZ3VhZ2UtdHlwZXMpXG4gKiBvZiBgT2JqZWN0YC4gKGUuZy4gYXJyYXlzLCBmdW5jdGlvbnMsIG9iamVjdHMsIHJlZ2V4ZXMsIGBuZXcgTnVtYmVyKDApYCwgYW5kIGBuZXcgU3RyaW5nKCcnKWApXG4gKlxuICogQHNpbmNlIDMuMC4wXG4gKiBAY2F0ZWdvcnkgTGFuZ1xuICogQHBhcmFtIHsqfSB2YWx1ZSBUaGUgdmFsdWUgdG8gY2hlY2suXG4gKiBAcmV0dXJuIHtib29sZWFufSBSZXR1cm5zIGB0cnVlYCBpZiBgdmFsdWVgIGlzIGFuIG9iamVjdCwgZWxzZSBgZmFsc2VgLlxuICpcbiAqIEBtZW1iZXJPZiBpc1xuICogQHNlZSBodHRwczovL2dpdGh1Yi5jb20vbG9kYXNoL2xvZGFzaC9ibG9iL21hc3Rlci9pc09iamVjdC5qc1xuICogQE5PVEUgT2JqZWN0LnByb3RvdHlwZS50b1N0cmluZy5jYWxsKHZhbCkgPT09ICdbb2JqZWN0IE9iamVjdF0nXG4gKlxuICogQGV4YW1wbGVcbiAqXG4gKiBpc09iamVjdCh7fSlcbiAqIC8vID0+IHRydWVcbiAqXG4gKiBpc09iamVjdChbMSwgMiwgM10pXG4gKiAvLyA9PiB0cnVlXG4gKlxuICogaXNPYmplY3QoRnVuY3Rpb24pXG4gKiAvLyA9PiB0cnVlXG4gKlxuICogaXNPYmplY3QobnVsbClcbiAqIC8vID0+IGZhbHNlXG4gKi9cbm1vZHVsZS5leHBvcnRzID0geCA9PiBvYmpTdHJpY3QoeCkgfHwgaXNGdW5jdGlvbih4KVxuIl0sIm5hbWVzIjpbImNvbnN0Il0sIm1hcHBpbmdzIjoiQUFBQUEsR0FBSyxDQUFDLFNBQVMsR0FBRyxPQUFPLENBQUMsYUFBYSxDQUFDO0FBQ3hDQSxHQUFLLENBQUMsVUFBVSxHQUFHLE9BQU8sQ0FBQyxZQUFZLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBZ0N4QyxNQUFNLENBQUMsT0FBTyxHQUFHLFVBQUEsQ0FBQyxDQUFBLENBQUMsQUFBRyxTQUFBLFNBQVMsQ0FBQyxDQUFDLENBQUMsSUFBSSxVQUFVLENBQUMsQ0FBQyxDQUFDLEdBQUE7In0=